export enum QueryKeys {
  Deals = 'Deals'
}

export interface Image {
  alt: string;
  url: string;
}

export interface DealmaticData {
  DealsPage: Deal[];
}

export interface IDealDate { 
  startDate: string;
  endDate: string;
}

export interface DealTile { 
  title: string;
  image?: {
    url: string;
    alt: string;
  };
  dealNameLg: string;
  dealNameSm: string;
  instructions: string;
  promo: string;
  offerEnds: string;
  legal: string;
  readMore: string;
  dealUrl?: string;
  buttonText?: string;
}

export interface Deal extends DealTile{
  template: string;
  locale: string;
  dates?: IDealDate[];
  startDate?: string;
  endDate?: string;
  isErrored?: boolean;
  link?: DealLink;
}

export interface DealLink {
  url: string;
  text: string;
}
